import React from "react";
import { useNavigation } from "../../../helpers/navigationHelpers";
import { ActiveWebsitePage } from "../../../types/ActiveWebsitePageEnum";
import styles from "./header.module.css";

export const Header: React.FC = () => {
  const { navigateToPage } = useNavigation();

  const navigationItems = [
    { page: ActiveWebsitePage.Home, label: "Home" },
    { page: ActiveWebsitePage.AboutUs, label: "Wie we zijn" },
    { page: ActiveWebsitePage.FAQ, label: "Veelgestelde vragen" },
  ];

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        {/* Logo */}
        <div className={styles.logo}>
          <img
            src="/logo/Opluchtpost - Logo RGB - Midres.png"
            alt="OpluchtPost Logo"
            className={styles.logoImage}
            onClick={() => navigateToPage(ActiveWebsitePage.Home)}
          />
        </div>

        {/* Navigation */}
        <nav className={styles.navigation}>
          {navigationItems.map(({ page, label }) => (
            <button key={page} className={`${styles.navButton}`} onClick={() => navigateToPage(page)}>
              {label}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
};
